//region 1. Platform Libraries
import express from 'express';
//endregion

const context = {
    router: express.Router(),
    logger: null,
};

context.router.get('/', (req, res) => {
    const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: 'GET /health' });
    res.type('text/plain');
    res.status(200).send(new Buffer('HEALTHY'));
    log('debug', '200 OK');
});

//noinspection JSUnusedGlobalSymbols
/**
 * Mount router for /health
 * @param {object}         options          Options
 * @param {object}         options.app      Express App
 * @param {winston.Logger} options.logger   Logger
 */
export default function mountHealth(options) {
    context.logger = options.logger;
    const log = (lvl, msg) => context.logger.log(lvl, msg, { tags: 'mountHealth' });
    log('debug', 'Mounting router for /health....');
    options.app.use('/health', context.router);
    log('info', 'Router for /recorders Mounted');
}
